import { Layout } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileUpload } from '../../simple-form-components';
import { BundledProduct, ProductTypeEN } from 'cpfr-common';

interface ChangeDurationMileageFormProps {
    productTypeEn: ProductTypeEN | undefined;
    bundledProducts?: BundledProduct[];
}

export const CreditUpload: React.FC<ChangeDurationMileageFormProps> = ({ productTypeEn, bundledProducts }) => {
    const { t } = useTranslation('request');
    const translationPrefix = 'category-selection.vehicle-claim.files.credit';

    const translate = (key: string): string => {
        return t(`${translationPrefix}.${key}`);
    };

    const isInvoiceMandatory =
        productTypeEn === ProductTypeEN.CREDIT &&
        (bundledProducts ?? []).some((p) => p.name === 'Garantie Capital Auto' && p.status === 'ACTIVE');

    return (
        <>
            {isInvoiceMandatory && (
                <Layout.Item>
                    <FileUpload
                        name={'vehicleClaim.nonReparableFields.files.invoice'}
                        label={translate('file-one')}
                        isMandatory
                        multiple
                    />
                </Layout.Item>
            )}
            <Layout.Item>
                <FileUpload
                    name={'vehicleClaim.nonReparableFields.files.paymentDetails'}
                    label={translate('file-two')}
                    isMandatory={false}
                    multiple
                />
            </Layout.Item>
        </>
    );
};
